import * as React from 'react';
import PropTypes from 'prop-types';
import { DataGrid } from '@mui/x-data-grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {useState, useEffect, useCallback, useRef} from 'react';
import axios from 'axios';
import DeleteButton from './DeleteBotten'
import CircularProgress from '@mui/material/CircularProgress'
import { green } from '@mui/material/colors'


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function BasicTabs() {
  const columns = [
    {
      field: 'deleteBtn',
      headerName: '削除',
      sortable: false,
      width: 90,
      disableClickEventBubbling: true,
      renderCell: (params) => <DeleteButton rowId={ params.id } getFormData={ getFormData } />
    },
    { 
      field: 'id', 
      headerName: 'ID', 
      width: 50 
    },
    { 
      field: 'name', 
      headerName: '地点名', 
      width: 100 
    },
    { 
      field: 'input_datetime', 
      headerName: '入力した時間', 
      width: 200 },
    {
      field: 'datetime',
      headerName: '計測時間',
      width: 200,
    },
    {
      field: 'value',
      headerName: '積雪深値',
      type: 'number',
      width: 100,
    },
  ];

  // 要素の取得
  const tabItem = document.querySelectorAll(".tab-item");
  const tabContent = document.querySelectorAll(".tab-content");

  // tabItemに対してクリックイベントを追加
  // クリックした時にtabToggle関数を発火
  for (let i = 0; i < tabItem.length; i++) {
    tabItem[i].addEventListener("click", tabToggle);
  }

  function tabToggle() {
    // tabItemとtabContentの.activeを削除する
    for (let i = 0; i < tabItem.length; i++) {
      tabItem[i].classList.remove("active");
    }
    for (let i = 0; i < tabContent.length; i++) {
      tabContent[i].classList.remove("active");
    }

    // クリックしたtabItemに.activeを追加
    this.classList.add("active");

    // tabItemを配列にする
    // [<li class="tab-item active">About</li>, <li class="tab-item">Works</li>, <li class="tab-item">Contact</li>]
    const aryTabs = Array.prototype.slice.call(tabItem);

    // 配列に格納したキーワードと最初一致したインデックスを格納
    // <li class="tab-item active">About</li>の場合は「0」が返ってくる
    const index = aryTabs.indexOf(this);

    // インデックスに対応したtabContentに.activeを追加
    tabContent[index].classList.add("active");
  }
  const [posts, setPosts] = useState([])
  const [selectedPlace, setSelectedPlace] = useState('')
  const [selectedFileName, setSelectedFileName] = useState('ファイルを選択')
  const [isUploading, setIsUploading] = useState(false)
  const [isSetFile, setIsSetFile] = useState(false)

  useEffect(() => {
    axios.get('/api/places')
      .then(res => {
        setPosts(res.data)
        if (res.data.length > 0) {
          setSelectedPlace(res.data[0].subname)
        }
      })
  }, [])

  const handleselectedFile = (event) => {
    setSelectedFileName(event.target.files[0].name)
    setIsSetFile(true)
  }

  const handlePlaceChange = (event) => {
    setSelectedPlace(event.target.value)
  };

  const onPostForm = useCallback((data) => {
    try {
      setIsUploading(true)
      // Object の data を FormData 形式に変換する
      const params = new FormData();
      Object.keys(data).forEach(function(key) {
        params.append(key, this[key]);
      }, data);
  axios.post('/api/snow_dpt/csv', params, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(res => {
          setIsUploading(false)
          alert('アップロードが完了しました')
        })
    } catch(err) {
      console.log(err);
      setIsUploading(false)
    }
  }, []);

  const ref = useRef(null);

  const onSubmitHandler = useCallback((e) => {
    e.preventDefault();
    if (isSetFile === false) {
      alert('アップロードするCSVファイルを選択してください')
      return
    }
    onPostForm({
      file: ref.current.files[0],
      subname: selectedPlace
    });
  });

  const [formdata, setFormdata] = useState([])
  useEffect(() => {
    if (selectedPlace !== '') {
      axios.get(`/api/form/data/${selectedPlace}`).then(res => {
        setFormdata(res.data)
        console.log(res.data)
      })
    }
  }, [selectedPlace])

  const handleTabDataClick = (() => {
    getFormData()
  })

  const getFormData = (() => {
    if (selectedPlace !== '') {
      axios.get(`/api/form/data/${selectedPlace}`).then(res => {
        setFormdata(res.data)
      })
    }
  })

  return (
    <React.Fragment>
      <link rel="stylesheet" href="/css/detail.css" />
      <link rel="stylesheet" href="/css/form.css" />
      <main>
        <section>
           {isUploading && (
          <CircularProgress
            size={24}
            sx={{
              color: green[500],
              position: 'absolute',
              top: '50%',
              left: '50%',
              marginTop: '-12px',
              marginLeft: '-12px',
            }}
          />
        )}
          <div class="ly_section">
            <div class="bl_section">
              <div class="bl_snowCoverTtl">
                <div class="el_snowCoverTtl__logo">
                  <img src="/img/snow_logo.png" alt="" />
                </div>
                <div class="el_snowCoverTtl__name">
                  <h2>積雪深値</h2>
                </div>
              </div>
              <div class="bl_snowCoverBtn">
                <ul class="tab-list">
                  <li class="tab-item active">
                    <div class="bl_itemInner">
                      <div class="el_btnIcon">
                        <img src="/img/input_btn.png" alt="" />
                      </div>
                      <div class="el_btnTtl">
                        <p>入力用</p>
                      </div>
                    </div>
                  </li>
                  <li class="tab-item">
                    <div class="bl_itemInner bl_itemInner__list" onClick={handleTabDataClick}>
                      <div class="el_btnIcon">
                        <img src="/img/list_btn.png" alt="" />
                      </div>
                      <div class="el_btnTtl">
                        <p>データ一覧</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="bl_containerInner">
                <div class="tab-container">
                  <div class="tab-content active">
                    <form class="bl_contentInner" onSubmit={onSubmitHandler}>
                      <div class="bl_pointForm">
                        <div class="el_pointForm__name">
                          <p>地点名</p>
                        </div>
                        <div class="el_pointForm__in">
                          <select
                            value={selectedPlace}
                            onChange={handlePlaceChange}
                          >
                            {posts.map((post) => (
                              <option
                                value={post.subname}
                              >
                                {post.subname}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div class="bl_csvForm">
                        <div class="el_csvForm__name">
                          <p>CSVファイル</p>
                        </div>
                        <div class="bl_csvFormBl">
                          <label class="el_csvForm__file">
                            { selectedFileName }
                            <input type="file" accept="text/csv" name="csv" ref={ref} onInput={handleselectedFile} />
                          </label>
                          <button class="el_csvForm__up" type="submit" disabled={isUploading}>アップロード</button>
                        </div>
                        </div>
                      </form>
                    </div>
                  <div class="tab-content">
                    <div class="bl_contentInnerNext">
                      <div class="bl_pointFormDate">
                        <div class="el_pointFormDate__name">
                          <p>地点名</p>
                        </div>
                        <div class="el_pointFormDate__in">
                          <select
                            value={selectedPlace}
                            onChange={handlePlaceChange}
                          >
                            {posts.map((post) => (
                              <option
                                value={post.subname}
                              >
                                {post.subname}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div style={{ height: 400, width: '100%' }}>
                      <DataGrid
                        rows={formdata}
                        columns={columns}
                        pageSize={20}
                        rowsPerPageOptions={[20]}
                        style={{ width: '800px', marginTop: '30px' }}
                        disableColumnMenu={true}
                        columnThreshold={columns.length}
                        columnBuffer={columns.length}
                        isRowSelectable={() => false}
                      />
                    </div>
                    <div class="el_pointList">
                      <img src="/img/deta_list.jpg" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}
